import FacilityPage from './facility-page'
import FacilityPageQuery, { FACILITY_QUERY } from './facility-page.query'

export { FacilityPageQuery, FACILITY_QUERY }

export default FacilityPage
